import { createFileRoute, Outlet, redirect } from "@tanstack/solid-router";
import { orpc } from "~/lib/orpc";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location, context }) => {
    const session = await context.queryClient.ensureQueryData(
      orpc.auth.getSession.queryOptions(),
    );

    if (!session) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
  },
  component: () => <Outlet />,
});
